const DB_NAME = "video-recorder";
const DB_VERSION = 2;
const CHUNKS = "chunks";
const SEGMENTS = "segments";
const openDB = () => {
    return new Promise((resolve, reject) => {
        const req = indexedDB.open(DB_NAME, DB_VERSION);
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(CHUNKS)) {
                db.createObjectStore(CHUNKS, {
                    keyPath: "id",
                    autoIncrement: true,
                });
            }
            if (!db.objectStoreNames.contains(SEGMENTS)) {
                db.createObjectStore(SEGMENTS, {
                    keyPath: "id",
                });
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
};
export const saveChunk = async (blob, segmentId) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(CHUNKS, "readwrite");
        tx.objectStore(CHUNKS).add({
            segmentId,
            blob,
            createdAt: Date.now(),
        });
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
};
export const getAllChunks = async (segmentId) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(CHUNKS);
        const req = tx.objectStore(CHUNKS).getAll();
        req.onsuccess = () => {
            const chunks = req.result
                .filter((x) => x.segmentId === segmentId)
                .map((x) => x.blob);
            resolve(chunks);
        };
        req.onerror = () => reject(req.error);
    });
};
export const clearChunks = async (segmentId) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(CHUNKS, "readwrite");
        const store = tx.objectStore(CHUNKS);
        const req = store.getAll();
        req.onsuccess = () => {
            req.result.forEach((item) => {
                if (item.segmentId === segmentId) {
                    store.delete(item.id);
                }
            });
        };
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
};
export const createSegmentMeta = async (meta) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(SEGMENTS, "readwrite");
        tx.objectStore(SEGMENTS).put(meta);
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
};
export const finishSegmentMeta = async (id, stoppedAt) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(SEGMENTS, "readwrite");
        const store = tx.objectStore(SEGMENTS);
        const req = store.get(id);
        req.onsuccess = () => {
            const value = req.result;
            if (!value)
                return;
            value.stoppedAt = stoppedAt;
            store.put(value);
        };
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
};
export const getSegmentMeta = async (id) => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(SEGMENTS);
        const req = tx.objectStore(SEGMENTS).get(id);
        req.onsuccess = () => { var _a; return resolve((_a = req.result) !== null && _a !== void 0 ? _a : null); };
        req.onerror = () => reject(req.error);
    });
};
export const getAllSegmentKeys = async () => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(SEGMENTS);
        const req = tx.objectStore(SEGMENTS).getAllKeys();
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
    });
};
